// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"SideScroller_outerContainer__23mdu","innerContainer":"SideScroller_innerContainer__3KY27","item":"SideScroller_item__Xrx5c","line":"SideScroller_line__3ZpyT"};